import React from 'react'

export const defaultValue = {
  rooms: [],
  canActivateRan: false,
  globalError: null,
  isFetching: false
}

export const RanContext = React.createContext(defaultValue)
